import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {AppComponent } from './app.component';
import {HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import {HttpHelpersModule} from "../common/http-helpers/http-helpers.module";
import {APP_BASE_HREF, CommonModule} from "@angular/common";
import {CldrIntlService, IntlService} from "@progress/kendo-angular-intl";
import {MessageService, RTL} from "@progress/kendo-angular-l10n";
import {AppConfigurationService} from "../common/app-config/app-configuration.service";
import {baseHrefFactory, initConfigFactory} from "../app-main/app-main.module";
import {WindowModule} from "@progress/kendo-angular-dialog";
import {EnvInitializer} from "../common/services/environement.initializer";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {AppAuthModule} from "../app-auth/app-auth.module";
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import {PopupModule} from "@progress/kendo-angular-popup";
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import {TranslateModule} from "../common/translate/translate.module";
import {MaskApplierService, NgxMaskModule} from "ngx-mask";
import {LanguageSelectionModule} from "../common/translate/language.selection.module";
import {MockModule} from "../common/mock/modules/mock.module";
import {ClickableElementModule} from "../common/directives/clickable.element/clickable.element.module";
import {CommonComponentsModule} from "../common/components/common.components.module";
import {ClickOutModule} from "../common/directives/click.out/click.out.module";
import {RouterModule} from "@angular/router";
import { ICON_SETTINGS } from "@progress/kendo-angular-icons";
import { NotificationModule } from '@progress/kendo-angular-notification';

require('./kendo.locale.imports');

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		HttpClientModule,
		AppRoutingModule,
		RouterModule,
		WindowModule,
		BrowserAnimationsModule,
		CommonModule,
		HttpHelpersModule,
		AppAuthModule,
		NgIdleKeepaliveModule.forRoot(),
		PopupModule,
		NgxMaterialTimepickerModule,
		TranslateModule,
		NgxMaskModule.forRoot(),
		WindowModule,
		LanguageSelectionModule,
		MockModule,
		ClickableElementModule,
		CommonComponentsModule,
		ClickOutModule,
		NotificationModule
	],
	providers: [
		{provide: APP_BASE_HREF, useFactory: baseHrefFactory},
		{provide: IntlService, useExisting: CldrIntlService},
		{provide: LOCALE_ID, useValue: 'en-US'},
		{provide: RTL, useValue: false},
		AppConfigurationService,
		CldrIntlService,
		MessageService,
		{
			provide: APP_INITIALIZER,
			useFactory: initConfigFactory,
			deps: [AppConfigurationService],
			multi: true,
			useExisting: true
		},
		MaskApplierService,
		{ provide: ICON_SETTINGS, useValue: { type: 'font' } }
	],
	bootstrap: [AppComponent]
})
export class AppModule { }


